<template>
	<li id="ortho_menu" class="nav-item dropdown active">
		<a id="ortho_header" class="nav-link" tabindex="0" data-toggle="dropdown" data-submenu aria-expanded="false"
			v-on:click="orthoHeaderClick()">Ortho</a>

		<div id="orthoMenu" class="dropdown-menu dropdown-menu-right">
			<button id="miEnterOrthoPlanMode" class="dropdown-item border-bottom-item" type="button"
				v-on:click="createStage(false)">
				New Stage
			</button>
			<button id="miEnterOrthoPlanMode" class="dropdown-item border-bottom-item" type="button"
				v-on:click="createStage(true)">
				New From Latest
			</button>
			<div class="dropdown dropright dropdown-submenu border-bottom-item">
				<button class="dropdown-item" type="button" v-on:click="orthoMenuClick($event)">Planned Stages</button>
				<div class="dropdown-menu secondary-menu">
					<button class="dropdown-item border-bottom-item" type="button" v-on:click="loadStageClick(-1)">
						Original Position
					</button>
					<!-- <button class="dropdown-item border-bottom-item"
						type="button" v-on:click="loadStageClick(0)">
						Last Position
					</button> -->
					<button v-for="(stage, index) in currentStages" :key="stage.id"
						class="dropdown-item border-bottom-item" type="button" v-on:click="loadStageClick(stage.id)">
						{{ stage.name }}
						<img class="trash-img" src="images/trash_icon_red.png"
							v-on:click="deleteStage(stage.id, $event)" />
					</button>
					<!-- <button v-if="isIntraoral" v-for="(stage, index) in intraoralStages" :key="stage.id"
						class="dropdown-item border-bottom-item" type="button" v-on:click="loadStageClick(stage.id)">
						{{ stage.name }}
						<img class="trash-img" src="images/trash_icon_red.png"
							v-on:click="deleteStage(stage.id, $event)" />
					</button> -->
				</div>
			</div>
			<button id="miPlayStages" class="dropdown-item border-bottom-item" type="button" v-on:click="playStages()">
				Play Stages
			</button>
			<!-- <button id="miStagesReport" class="dropdown-item border-bottom-item" type="button"
				v-on:click="stagesReport()">
				Stages Report
			</button> -->

			<!-- <button v-if="!isIntraoralView" id="miStagesReport" class="dropdown-item border-bottom-item" type="button"
				v-on:click="anatomyChangeReportClick()">
				Anatomy Change Report
			</button> -->

			<div v-if="treatmentStages && treatmentStages.length"
				class="dropdown dropright dropdown-submenu border-bottom-item">
				<button class="dropdown-item" type="button" v-on:click="orthoMenuClick($event)">Treatment
					Stages</button>
				<div class="dropdown-menu secondary-menu">
					<button v-for="(stage, index) in treatmentStages" :key="stage.id" :disabled="stage.disabled"
						class="dropdown-item border-bottom-item" type="button"
						v-on:click="loadTreatmentStageClick(stage.patientId, stage.url)">
						{{ stage.name }}
					</button>
				</div>
			</div>

			<button v-if="!isIntraoralView && isValidTreatment" id="miPlaySmartRoots"
				class="dropdown-item border-bottom-item" type="button" v-on:click="playSmartRoots()">
				Play Smart Roots
			</button>

			<AnchorageMenu v-if="!isIntraoralView" />

			<button v-if="!isIntraoralView && isOcclusionAvailable" id="miCrossBiteReport"
				class="dropdown-item border-bottom-item" type="button" v-on:click="crossBiteReportClick()">
				Cross Bite Report
			</button>

			<button v-if="!isIntraoralView" class="dropdown-item border-bottom-item" type="button"
				v-on:click="crossSectionReportClick()">
				Cross Section Report
			</button>

			<button v-if="!isIntraoralView" class="dropdown-item border-bottom-item" type="button"
				v-on:click="cutsReportClick()">
				Cuts Report
			</button>

			<button v-show="!isIntraoralView && hasReports"
				class="dropdown-item border-bottom-item" type="button" v-on:click="showReportsClick()">
				Saved Cuts Reports
			</button>

		</div>
	</li>
</template>

<script>
import { showCutReportsListDlg } from "@/components/dicom/reports/DicomCutReports.js";
import AnchorageMenu from "@/components/anchorage/AnchorageMenu.vue";

import { jsPDF } from "jspdf";
import $ from "jquery";
import swal from "sweetalert";

import {
	OrthoPlanMode,
	loadOrthoStage,
	initializeControls,
	// enterPlaySmartRoots,
	updatePlaySlider
} from "./OrthoPlanMode";

import {
	enterPlaySmartRoots
} from "./treatment/OrthoTreatment";

import { showOrthoStageDialog } from "./OrthoStageDialog.vue";
import { radiansToDegrees } from "../geometry/geometry";
import { saveViewerData } from "../saveLoadData";
import { getFormattedDate } from "../reports/fileMethods";
import { sendOrthoRemoveStageRequest } from "@/api/orthoApi";
import { anatomyChangeReport } from "./OrtoReporting";
import { generateCrossBiteReport } from "@/components/reports/CrossBiteManager.js";
import { generateCrossSectionReport, generateCutsReport } from "@/components/dicom/reports/DicomReports.js";
import { recordTreatmentVideo } from "@/components/ortho/treatment/OrthoTreatmentVideo";

export default {
	name: "OrthoMenu",
	props: [
		"hasReports", "currentStages", "treatmentStages",
		"isValidTreatment", "isIntraoral", "isIntraoralView",
		"isOcclusionAvailable"],
	components: {
		AnchorageMenu,
	},
	data() {
		return {
			playInitialized: false
		};
	},
	methods: {
		crossBiteReportClick: async function () {
			await generateCrossBiteReport();
		},
		crossSectionReportClick: async function () {
			await generateCrossSectionReport();
		},
		cutsReportClick: async function () {
			await generateCutsReport();
		},
		showReportsClick: async function () {
			await showCutReportsListDlg();
		},
		orthoHeaderClick: function () {
			// recordTreatmentVideo();
			if (vueApp.isStlLoaded && vueApp.downloadingStages) {
				swal({
					text: "Ortho data is loading. Please try a bit later...",
				});
			}
		},
		orthoMenuClick: function (event) {
			gtag('event', `Ortho->${event.srcElement.innerText}`);
		},
		createStage: function (useLatest) {
			gtag('event', 'Ortho->New Stage');
			initializeControls();
			showOrthoStageDialog(false, useLatest);
		},
		loadStageClick: function (stageId) {
			gtag('event', `Ortho->Load->${stageId}`);
			loadOrthoStage(stageId, true);
			if (this.playInitialized) {
				var sliderValue = stageId == -1 ? -1 : stageId - 1;
				updateSlider("#playSlider", vueApp.currentStages.length - 1, sliderValue);
			}
		},
		loadTreatmentStageClick: function (stageId, stageUrl) {
			gtag('event', `Ortho->Treatment Stage->${stageId}`);
			console.log("loadTreatmentStageClick", stageUrl, location.href);
			vueApp.reloadAppFromUrl(stageUrl);
		},
		deleteStage: function (stageId, event) {
			gtag('event', `Ortho->Delete->${stageId}`);
			if (event) {
				event.stopPropagation();
			}
			swal({
				text: "Are you sure you want to permanently delete this stage?",
				buttons: {
					yes: { text: "Yes", value: true },
					no: { text: "No", value: false }
				}
			}).then(willDelete => {
				if (willDelete) {
					let stage = vueApp.currentStages.find(s => s.id == stageId);
					if (!stage) {
						console.log("Deleted stage not found", stageId, vueApp.orthoStages);
					}
					let index = vueApp.orthoStages.indexOf(stage);
					if (stage.id == vueApp.currentStageId && OrthoPlanMode.isActive) {
						loadOrthoStage(-1);
						//leaveOrthoPlanMode();
					}

					vueApp.orthoStages.splice(index, 1);
					vueApp.savedData.orthoStages = JSON.parse(
						JSON.stringify(vueApp.orthoStages)
					);
					saveViewerData();

					$("#orthoPlayStagesDiv").css("display", "none");
					sendOrthoRemoveStageRequest(stage);
				}
			});
		},
		playSmartRoots: function () {
			gtag('event', 'Ortho->Play Smart Roots');

			enterPlaySmartRoots();
		},
		playStages: function () {
			gtag('event', 'Ortho->Play Stages');
			initializeControls();

			vueApp.hideClipping();
			let currentStages = vueApp.currentStages;
			console.log("playStages", currentStages.length, currentStages);
			vueApp.leaveModes(false, true, true);
			updatePlaySlider(currentStages.length - 1, -1);
			vueApp.currentStageId = -1;
			loadOrthoStage(vueApp.currentStageId);
			$("#orthoPlayStagesDiv").css("display", "block");
			OrthoPlanMode.isActive = true;
			$("#orthoStageDiv").css("display", "block");
		},
		anatomyChangeReportClick: function () {
			anatomyChangeReport();
		},
		stagesReport: function () {
			gtag('event', 'Ortho->Stages Report');
			const doc = new jsPDF();
			var teethMap = new Map(vueApp.allTeeth.map(i => [i.name, i]));
			let reportMap = new Map();

			vueApp.currentStages.forEach(function (stage) {
				var stageTeeth = JSON.parse(stage.teethString);
				var allTeeth = [];
				stageTeeth.forEach(function (model) {
					var savedPos = model.stagePosition;
					var savedRot = model.stageRotation;

					var tooth = teethMap.get(model.name);
					var reportItem = reportMap.get(model.name);

					var defPos = reportItem ? reportItem.lastPos : tooth.defaultPosition;
					var defRot = reportItem ? reportItem.lastRot : { x: 0, y: 0, z: 0 };

					var reportStage = getReportStage(
						tooth,
						stage,
						defPos,
						defRot,
						savedPos,
						savedRot
					);
					if (reportStage) {
						if (!reportItem) {
							reportItem = {
								id: tooth.id,
								name: tooth.name,
								tooth: tooth,
								stages: []
							};
							reportMap.set(model.name, reportItem);
						}

						reportItem.stages.push(reportStage);
						reportItem.lastPos = savedPos;
						reportItem.lastRot = savedRot;
					}

					allTeeth.push({
						id: model.id,
						name: model.name,
						stagePosition: model.stagePosition,
						stageRotation: model.stageRotation
					});
				});

				stage.teethString = JSON.stringify(allTeeth);
			});

			vueApp.savedData.orthoStages = JSON.parse(
				JSON.stringify(vueApp.orthoStages)
			);
			// saveViewerData();

			if (reportMap.size > 0) {
				var xOffset = 20;
				var x = xOffset;
				var yOffset = 20;
				var y = yOffset;
				var pageOffset = 50;
				var pageHeight = doc.internal.pageSize.height;
				var pageWidth = doc.internal.pageSize.width;
				doc.setFontSize(12);
				var lineSpace = 6;
				var stageSpace = 10;
				var toothSpace = 12;

				//var strings = [];
				for (var reportItem of reportMap.values()) {
					x = xOffset;
					doc.setFont("helvetica", "bold");
					doc.text(`Tooth ${reportItem.name}:`, x, y);
					doc.setFont("helvetica", "normal");

					var i = 0;
					var y0 = y;
					reportItem.stages.forEach(function (stage) {
						if (i % 2 == 0) {
							x = xOffset;
							y = y0 = y + stageSpace;
						} else {
							x = pageWidth / 2 + xOffset;
							y = y0;
						}

						if (y + pageOffset >= pageHeight) {
							doc.addPage();
							y = yOffset; // Restart height position
						}

						doc.text(`${stage.name}, from previous stage:`, x, y);
						doc.text(`x: ${stage.x} mm`, x, (y += lineSpace));
						doc.text(`y: ${stage.y} mm`, x, (y += lineSpace));
						doc.text(`z: ${stage.z} mm`, x, (y += lineSpace));
						doc.text(
							`rotation: ${stage.rotationX}, ${stage.rotationY}, ${stage.rotationZ} deg`,
							x,
							(y += lineSpace)
						);

						i += 1;
					});

					y += toothSpace;

					if (y + pageOffset > pageHeight) {
						doc.addPage();
						y = yOffset; // Restart height position
					}
				}
			}

			//doc.text("Tooth XX:", 10, 10);
			let fullName = `stagesReport_${getFormattedDate(true)}.pdf`;
			doc.save(fullName);
		}
	}
};

function getReportStage(tooth, stage, defPos, defRot, savedPos, savedRot) {
	var retval = null;

	if (!tooth || !stage || !defPos || !defRot || !savedPos || !savedRot) {
		return null;
	}

	if (
		Math.abs(savedPos.x - defPos.x) > 0.05 ||
		Math.abs(savedPos.y - defPos.y) > 0.05 ||
		Math.abs(savedPos.z - defPos.z) > 0.05 ||
		Math.abs(savedRot.x - defRot.x) > 0.01 ||
		Math.abs(savedRot.y - defRot.y) > 0.01 ||
		Math.abs(savedRot.z - defRot.z) > 0.01
	) {
		var dx = savedPos.x - defPos.x;
		var dy = savedPos.y - defPos.y;
		var dz = savedPos.z - defPos.z;

		var rdx = savedRot.x - defRot.x;
		var rdy = savedRot.y - defRot.y;
		var rdz = savedRot.z - defRot.z;

		retval = {
			name: stage.name,
			x: dx.toFixed(2),
			y: dy.toFixed(2),
			z: dz.toFixed(2),
			rotationX: radiansToDegrees(rdx).toFixed(2),
			rotationY: radiansToDegrees(rdy).toFixed(2),
			rotationZ: radiansToDegrees(rdz).toFixed(2)
		};
	}
	return retval;
}

</script>

<style>
#ortho_header {
	cursor: pointer;
}

.ortho-mode-item {
	position: absolute;
	text-align: center;
	z-index: 9;
	color: #ffffff;
	/*#797979;*/
	display: none;
}

.trash-img {
	width: 18px;
	margin-left: 8px;
	margin-bottom: 3px;
	cursor: pointer;
}
</style>